import { render, staticRenderFns } from "./Token.vue?vue&type=template&id=074379df&scoped=true&"
import script from "./Token.vue?vue&type=script&lang=js&"
export * from "./Token.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074379df",
  null
  
)

export default component.exports